import { useEffect, useRef, useState } from "react";

const reviews = [
  {
    name: "สมหญิง ใจดี",
    role: "แม่บ้าน · กรุงเทพฯ",
    avatar: "https://readdy.ai/api/search-image?query=Thai%20middle%20aged%20woman%20smiling%20happy%20portrait%20casual%20home%20background%20warm%20friendly%20face%20natural%20makeup&width=120&height=120&seq=avatar-001&orientation=squarish",
    rating: 5,
    text: "ตอนแรกไม่เชื่อเลยนะคะ คิดว่าหลอกแน่ๆ แต่พอลองดูแล้วถอนเงินได้จริง ตอนนี้ดูทุกวันเลยค่ะ ได้เงินเพิ่มอีกด้วย ซีรีส์ก็สนุกมาก",
    earned: "รับไปแล้ว ฿1,200",
    verified: true,
  },
  {
    name: "ธนกร วงศ์สุข",
    role: "นักศึกษา · เชียงใหม่",
    avatar: "https://readdy.ai/api/search-image?query=Thai%20young%20man%20student%20smiling%20casual%20portrait%20university%20background%20friendly%20confident%20face&width=120&height=120&seq=avatar-002&orientation=squarish",
    rating: 5,
    text: "ดูระหว่างนั่งรถไปมหาลัย ได้เหรียญทุกวัน ชวนเพื่อนมาอีก 5 คน ได้โบนัสเพิ่มอีกเยอะมาก แอปใช้งานง่ายมากครับ",
    earned: "รับไปแล้ว ฿850",
    verified: true,
  },
  {
    name: "นภาพร รักสนุก",
    role: "พนักงานออฟฟิศ · พัทยา",
    avatar: "https://readdy.ai/api/search-image?query=Thai%20young%20professional%20woman%20office%20worker%20smiling%20portrait%20confident%20happy%20casual%20business%20attire&width=120&height=120&seq=avatar-003&orientation=squarish",
    rating: 5,
    text: "ดูตอนพักเที่ยงทุกวัน ซีรีส์สนุกมาก ดูจบแล้วยังอยากดูต่อ แถมได้เงินด้วย ถอนผ่านกระเป๋า BEP20 เข้า USDT ได้เลย สะดวกมากค่ะ",
    earned: "รับไปแล้ว ฿2,100",
    verified: true,
  },
];

export default function Testimonials() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="testimonials" className="py-20 md:py-28 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-orange-50 text-orange-500 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            รีวิวจากผู้ใช้จริง
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            คนไทยพูดถึง Hongguo Drama
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            ผู้ใช้จริงกว่า 1 ล้านคน ไม่ใช่รีวิวปลอม
          </p>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {reviews.map((review, i) => (
            <div
              key={review.name}
              className={`bg-white rounded-2xl p-6 border border-gray-100 hover:-translate-y-1 transition-all duration-500 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
                {review.verified && (
                  <span className="ml-2 text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full flex items-center gap-1">
                    <i className="ri-verified-badge-line"></i> ยืนยันแล้ว
                  </span>
                )}
              </div>

              {/* Quote */}
              <div className="relative mb-6">
                <i className="ri-double-quotes-l text-4xl text-red-100 absolute -top-2 -left-1"></i>
                <p className="text-gray-700 text-sm leading-relaxed pl-6 relative z-10">
                  {review.text}
                </p>
              </div>

              {/* Earned badge */}
              <div className="inline-flex items-center gap-1.5 bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 text-yellow-700 text-xs font-bold px-3 py-1.5 rounded-full mb-5">
                <i className="ri-coin-line"></i>
                {review.earned}
              </div>

              {/* User Info */}
              <div className="flex items-center gap-3 pt-4 border-t border-gray-50">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">{review.name}</div>
                  <div className="text-gray-400 text-xs">{review.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { num: "1M+", label: "ผู้ใช้งานทั่วไทย", icon: "ri-user-line" },
            { num: "4.8★", label: "คะแนนเฉลี่ย", icon: "ri-star-line" },
            { num: "฿50M+", label: "จ่ายให้ผู้ใช้แล้ว", icon: "ri-money-dollar-circle-line" },
            { num: "99%", label: "ถอนเงินสำเร็จ", icon: "ri-shield-check-line" },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-6 bg-gradient-to-b from-red-50 to-orange-50 rounded-2xl">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-2xl text-red-500`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">{stat.num}</div>
              <div className="text-gray-500 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
